import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { getBaseUrl } from '@shared';
import { getAuth0Tenant } from '@client';

const getSearchParam = (
  searchParams: URLSearchParams,
  param: string,
): string | undefined => {
  const value = searchParams.get(param);
  return value !== null ? value : undefined;
};

export const useAuthorizationParams = () => {
  const location = useLocation();

  return useMemo(() => {
    const searchParams = new URLSearchParams(location.search);

    // Always extract search params as base
    const priceId = getSearchParam(searchParams, 'price_id');
    const client_sign_in = getSearchParam(searchParams, 'client_sign_in');
    const searchParamRedirectTo = getSearchParam(searchParams, 'redirect_to');
    const searchParamLoginHint = getSearchParam(searchParams, 'login_hint');

    const baseUrl = getBaseUrl();
    const env = baseUrl.includes('localhost')
      ? 'LOCAL'
      : baseUrl.includes('dev')
        ? 'DEV'
        : 'PROD';

    const { audience } = getAuth0Tenant();

    // Build authorization params - only from search params now
    const authParams: Record<string, any> = {
      audience,
      redirect_uri: window.location.origin, // Always use origin as Auth0 callback
    };

    if (searchParamLoginHint) {
      authParams['login_hint'] = searchParamLoginHint;
    }

    if (client_sign_in === 'true') {
      authParams['connection'] = 'email';
    }

    if (priceId) {
      authParams['ext-price_id'] = priceId;
    }

    if (client_sign_in === 'true') {
      authParams['ext-client_sign_in'] = 'true';
    }

    authParams['ext-env'] = env;

    return {
      authorizationParams: authParams,
      searchParams: {
        priceId,
        clientSignIn: client_sign_in,
        redirectTo: searchParamRedirectTo,
        loginHint: searchParamLoginHint,
      },
    };
  }, [location.search]);
};
